import { render, staticRenderFns } from "./priorityselectmodal.vue.html?vue&type=template&id=3fc3fe5d&scoped=true"
import script from "./priorityselectmodal.controller?vue&type=script&lang=js&external"
export * from "./priorityselectmodal.controller?vue&type=script&lang=js&external"
import style0 from "./priorityselectmodal.vue.html?vue&type=style&index=0&id=3fc3fe5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3fe5d",
  null
  
)

export default component.exports